// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturesList_container__1tPeE"};